import React from 'react'
import { createStore, applyMiddleware } from 'redux'
import { composeWithDevTools } from 'redux-devtools-extension'
import createSagaMiddleware from 'redux-saga'
import { Provider } from 'react-redux'
import App from 'next/app'
import withRedux from 'next-redux-wrapper'

import rootSagas from '../state/rootSagas'
import reducer from '../state/rootReducer'

import '../styles/index.scss?global'

const sagaMiddleware = createSagaMiddleware()

function configureStore(initialState) {
  const store = createStore(
    reducer,
    initialState,
    composeWithDevTools(
      applyMiddleware(sagaMiddleware),
    ),
  )

  store.runSagaTask = () => {
    store.sagaTask = sagaMiddleware.run(rootSagas)
  }

  store.runSagaTask()

  return store
}

class MyApp extends App {
  handleMessage = (event) => {
    const possibleOrigins = [
      'http://localhost:3000',
      'http://dashboard.caseme.local',
      'https://dashboard.casemehml.com.br',
      'https://dashboard.caseme.com.br',
    ]

    if (possibleOrigins.includes(event.origin) && window !== undefined) {
      if (event.data.action === 'redirect' && event.data.url && window.location.pathname !== event.data.url) {
        window.location.href = event.data.url
      } else {
        window.location.reload()
      }
    }
  }

  componentDidMount() {
    window.addEventListener('message', this.handleMessage, false)   

  }

  componentWillUnmount() {
    window.removeEventListener('message', this.handleMessage, false)
  }

  render() {
    const { Component, pageProps, store } = this.props

    return (
      <Provider store={store}>
        <Component {...pageProps} />
      </Provider>
    )
  }
}

export default withRedux(configureStore)(MyApp)
